import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy URL — partner settings are a section of the unified Settings page. */
export const Route = createFileRoute("/_layout/admin/")({
	beforeLoad: () => {
		throw redirect({
			to: "/settings",
			search: { view: "partner", section: "partner" },
			replace: true,
		});
	},
});
